export default "__VITE_ASSET__BUwNLzWm__"